import client from "./client";

// المواد المركزية: كل مادة تعيش داخل فرع (branch_id إلزامي في الإنشاء).
const M = "/master-items";
export const listItemTypes = async () => (await client.get(`${M}/item-types`)).data;
export const checkDuplicate = async (name, branchId, excludeId) =>
  (await client.get(`${M}/items/check-duplicate`,
    { params: { name, branch_id: branchId, exclude_id: excludeId } })).data;
export const listItems = async (params) => (await client.get(`${M}/items`, { params })).data;
export const itemStats = async (branchId) =>
  (await client.get(`${M}/items/stats`, { params: branchId ? { branch_id: branchId } : {} })).data;
export const getItem = async (itemId) => (await client.get(`${M}/items/${itemId}`)).data;
export const nextCode = async (branchId, accountingCategory) =>
  (await client.get(`${M}/items/next-code`,
    { params: { branch_id: branchId, accounting_category: accountingCategory } })).data;
export const createItem = async (payload) => (await client.post(`${M}/items`, payload)).data;
export const updateItem = async (itemId, payload) =>
  (await client.put(`${M}/items/${itemId}`, payload)).data;
export const deleteItem = async (itemId) => (await client.delete(`${M}/items/${itemId}`)).data;
export const searchItems = async (q, branchId, limit = 20) =>
  (await client.get(`${M}/search-items`, { params: { q, branch_id: branchId, limit } })).data;
export const checkPrice = async (masterItemId, unitPrice) =>
  (await client.post(`${M}/items/check-price`,
    { master_item_id: masterItemId, unit_price: unitPrice })).data;
export const priceHistory = async (itemId) =>
  (await client.get(`${M}/items/${itemId}/price-history`)).data;
export const backfillReferencePrices = async () =>
  (await client.post(`${M}/items/backfill-reference-prices`)).data;
export const importItems = async (branchId, file) => {
  const body = new FormData();
  body.append("branch_id", branchId);
  body.append("file", file);
  return (await client.post(`${M}/import-items`, body,
    { headers: { "Content-Type": "multipart/form-data" } })).data;
};
export const downloadTemplate = async () =>
  (await client.get(`${M}/download-import-template`, { responseType: "blob" })).data;
